import React, { Component } from 'react';

class Rating extends Component {

  state = {
    winners: [
      {"user":"Влад Жучков","time":6,"score":17},
      {"user":"Михаил Станкеев","time":6,"score":17},
      {"user":"Ксюша Мартемьянова","time":6,"score":17}
    ]
  }

  renderTableRows = () => {
    const { winners } = this.state
    return winners.map((winner, index) => {
        return (
          <tr className={index < 3 ? 'row--winner' : null} key={winner.user}>
            <td>
            <span>
              {index < 3 ? <img src="/images/cup.png" alt="" className="rating__cup"/> : null}
              {index+1}. {winner.user}
            </span>
            </td>
            <td>
            <span>
              <img src="/images/ok.svg" alt="" className="rating__ok"/>
              {winner.score}/17
            </span>
            </td>
            <td>
            <span>
              <img src="/images/stopwatch.png" alt="" className="rating__watch"/>
              {winner.time}
            </span>
            </td>
          </tr>
        )
    })
  }

  render () {
    return (
      <div className="test__rating">
        <h1 className="h1 h1--finish">Победители 3 этапа</h1>

        <div className="rating__text">Перед вами таблица победителей. </div>

        <table className="rating__table">
          <tbody>
            {this.renderTableRows()}
          </tbody>
        </table>
      </div>
    )
  }
}

export default Rating


// WEBPACK FOOTER //
// ./src/pages/test/winners3.js